import { useContext } from "react"
import { SegmentContext } from "./SegmentContext"

export function useSegment() {
  const context = useContext(SegmentContext)
  if (!context) {
    throw new Error("useSegment must be used within a SegmentContextProvider")
  }
  return context
}
